import { useAppSelector } from "app/hooks";
import { MatchesViewer } from "components/MatchesViewer/MatchesViewer";
import { SwissMatchesViewer } from "components/MatchesViewer/Swiss/SwissMatchesViewer";
import { Panel } from "components/Panel/Panel";
import { MmSwissTable } from "components/ResultTable/Swiss/Mm/MmSwissTable";
import { SetSwissTable } from "components/ResultTable/Swiss/Set/SetSwissTable";
import { SwissTable } from "components/ResultTable/Swiss/SwissTable";
import { TabBar } from "components/TabBar/TabBar";
import { Filter } from "model/Filter/Filter";
import { Theme } from "model/Theme";
import { getRoundName } from "model/Tournament/Segment/RoundsSegmentGroup";
import {
  Swiss,
  canGroupSwissMatches,
} from "model/Tournament/Segment/Swiss/Swiss";
import { GrowColumn } from "pages/styles";
import { useState } from "react";
import { selectMatchesRosterIds } from "selectors/Match";

interface Props {
  swiss: Swiss;
  tournamentId: string;
  theme: Theme | undefined;
}

// todo - lots of dupe code with Season equivalent
export const SwissTabContent = ({ swiss, tournamentId, theme }: Props) => {
  const swissOptions = swiss.rounds.map((r) =>
    getRoundName(r, swiss.roundPrefix)
  );
  const [selectedTab, setSelectedTab] = useState(swissOptions[0]);
  const swissFilter: Filter<string> = {
    options: swissOptions,
    selectedValue: selectedTab,
    setSelectedValue: setSelectedTab,
  };

  const selectedRound = getRoundFromOption(swiss, swissFilter.selectedValue);
  const rosterIds = useAppSelector((state) =>
    selectMatchesRosterIds(
      state,
      swiss.rounds.flatMap((r) => r.matchIds)
    )
  );

  return (
    <GrowColumn>
      {rosterIds.length > 0 && (
        <Panel>
          {tournamentId === "Tmwt2023S2Allstars" ? (
            <SetSwissTable
              swiss={swiss}
              rosterIds={rosterIds}
              tournamentId={tournamentId}
            />
          ) : tournamentId === "Mts2024Spring" ? (
            <MmSwissTable
              swiss={swiss}
              rosterIds={rosterIds}
              tournamentId={tournamentId}
            />
          ) : (
            <SwissTable
              swiss={swiss}
              rosterIds={rosterIds}
              tournamentId={tournamentId}
            />
          )}
        </Panel>
      )}

      <Panel>
        <TabBar filter={swissFilter} isSecondaryTabBar={true} />
        {!!selectedRound &&
          (canGroupSwissMatches(swiss) ? (
            <SwissMatchesViewer
              matchIds={selectedRound.matchIds}
              priorMatchIds={swiss.rounds
                .filter((r) => r.roundNum < selectedRound.roundNum)
                .flatMap((r) => r.matchIds)}
              tournamentId={tournamentId}
              hoverColor={theme?.secondary}
            />
          ) : (
            <MatchesViewer
              matchIds={selectedRound.matchIds}
              tournamentId={tournamentId}
            />
          ))}
      </Panel>
    </GrowColumn>
  );
};

const getRoundFromOption = (swiss: Swiss, option: string) => {
  const roundNumString = option.slice(-1);
  const roundNum = parseInt(roundNumString);
  return swiss.rounds.find((r) => r.roundNum === roundNum);
};
